/* eslint-disable no-unused-vars */

import http from '../http.service';
import { cacheWorkOrderPhotosAndDocuments } from './json-manipulation/tasks';

const fetchDataFromAllAPIs = async ({ apisList, apiListWithHttp }) => {
  try {
    http.setJWT();
    let allApisResponse = await Promise.allSettled([...apiListWithHttp]);
    const failedAPIsList = [];
    const apiThatFailedAgainOnRefetch = [];

    let cachingFailure = localStorage.getItem('cachingFailure') === 'true' ? true : false;
    if (!cachingFailure)
      for (let responseOfAPIs of allApisResponse) {
        if (responseOfAPIs.status === 'rejected') {
          failedAPIsList.push({
            index: allApisResponse.indexOf(responseOfAPIs),
            URL: apisList[allApisResponse.indexOf(responseOfAPIs)]
          });
        }
      }
    if (failedAPIsList?.length > 0) {
      const apisList = failedAPIsList?.map((x) => {
        return http.get(x?.URL.URL);
      });
      const refetchAPIResponse = await Promise.allSettled([...apisList]);
      for (let responseOfAPIs in refetchAPIResponse) {
        if (refetchAPIResponse[responseOfAPIs].status === 'fulfilled') {
          const index = failedAPIsList[responseOfAPIs].index;
          allApisResponse[index] = refetchAPIResponse[responseOfAPIs];
        } else if (refetchAPIResponse[responseOfAPIs].status === 'rejected') {
          console.log({ refetchAPIResponse }, failedAPIsList);

          apiThatFailedAgainOnRefetch.push({
            index: failedAPIsList[responseOfAPIs].index
          });
        }
      }
    }

    if (apiThatFailedAgainOnRefetch?.length > 0)
      throw new Error('some of the API has been cancelled');

    let apisModifiedResponse = {};

    for (let apiIndex in allApisResponse) {
      let index = parseInt(apiIndex);
      const apiKey = apisList[index].key;
      apisModifiedResponse = {
        ...apisModifiedResponse,
        [apiKey]: allApisResponse[index].value?.data || {}
      };

      if (apiKey === 'WorkOrderCache/MobileCache') {
        const settingIndex = apisList?.findIndex((x) => x?.key === 'UserMobileSettings');
        const newSettings = allApisResponse[settingIndex].value?.data || null;
        await cacheWorkOrderPhotosAndDocuments({
          workOrderCache: allApisResponse[index].value?.data,
          newSettings
        });
      }
    }
    return apisModifiedResponse;
  } catch (error) {
    window.stop();
    console.log({ error });
    throw new Error(error);
  }
};

export { fetchDataFromAllAPIs };
